/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from '../../components/courseLanding';
import SectionTitle from '../../components/sectionTitle';
import Quiz from '../../components/quiz';
import Conversation from './conversation';
import Animation008 from './animation008';
import Animation021 from './animation021';
import Animation022 from './animation022';
import Animation023 from './animation023';
import Animation028 from './animation028';
import Animation031 from './animation031';
import Animation032 from './animation032';
import Animation033 from './animation033';
import Animation034 from './animation034';
import Animation038 from './animation038';
import Animation041 from './animation041';
import Animation043 from './animation043';
import Animation044 from './animation044';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation008,
  Animation021,
  Animation022,
  Animation023,
  Animation028,
  Animation031,
  Animation032,
  Animation033,
  Animation034,
  Animation038,
  Animation041,
  Animation043,
  Animation044,
  Component001,
  Component002,
  Component003,
  Component004,
};

export default Components;
